<link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap" rel="stylesheet"/>

<style>
    .rounded-2xl { border-radius: 1rem; }
    .rounded-3xl { border-radius: 1.5rem; }
    .transition-all { transition: all 0.2s ease-in-out; }
    .cursor-pointer { cursor: pointer; }
    .sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0; }
    .apple-pay-btn { background-color: #000; color: #fff; }
    .gpay-btn { background-color: #fff; color: #000; border: 1px solid #dee2e6; }
</style>

<div class="container-fluid p-0 shadow-lg bg-white min-vh-100" style="max-width: 450px; min-height: 100vh; overflow-x: hidden; display: flex; flex-direction: column;">

    <div class="position-relative overflow-hidden bg-dark text-white" style="height: 200px;">
      <div class="position-absolute w-100 h-100"
           style="background: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.6)),
                url('https://ammosny.com/wp-content/uploads/2022/10/Ammos002.jpg') center/cover no-repeat;">
        <div class="position-absolute bottom-0 p-4 w-100">
          <img src="https://ammosny.com/wp-content/uploads/2022/09/Logo04.svg"
               alt="Ammos Estiatorio"
               class="img-fluid"
               style="max-height: 80px; max-width: 200px; filter: brightness(0) invert(1);">
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center shadow"
         style="position: relative;
              top: -40px;
              left: 320px;
              background-color: rgba(255, 255, 255, 1);
              border-radius: 50%;
              width: 70px;
              height: 70px;">

      <svg viewBox="0 0 272 127" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scale(1.4); transform-origin: center;">
        <g clip-path="url(#clip0_1834_13831)">
          <path d="M110 58.5512C108.896 58.5512 108.001 57.6572 108 56.5522C107.997 52.1362 109.314 47.9182 111.524 45.2622L114.986 40.9342C115.676 40.0712 116.935 39.9322 117.797 40.6222C118.66 41.3122 118.799 42.5712 118.109 43.4332L114.634 47.7772C114.625 47.7882 114.616 47.7992 114.607 47.8102C112.996 49.7372 111.997 53.0862 111.999 56.5492C111.999 57.6532 111.105 58.5502 110.001 58.5502H109.999L110 58.5512Z" fill="#3D45E0"/>
          <path d="M149.181 95.9999H114.891C107.973 95.9999 100.032 94.3679 100.032 81.6389L100 56.5589C99.994 50.2269 101.918 44.2889 105.277 40.2629L111.14 32.9329C111.83 32.0709 113.089 31.9309 113.951 32.6209C114.814 33.3109 114.953 34.5699 114.263 35.4319L108.387 42.7779C108.378 42.7889 108.369 42.8009 108.359 42.8119C105.624 46.0809 103.994 51.2179 103.999 56.5539L104.031 81.6359C104.031 85.8849 105.004 88.6869 107.005 90.2039C108.643 91.4459 111.075 91.9989 114.889 91.9989H149.179C154.053 91.9989 156.784 91.0649 158.312 88.8759C158.944 87.9699 160.191 87.7479 161.097 88.3799C162.003 89.0119 162.225 90.2589 161.593 91.1649C158.604 95.4489 153.389 95.9989 149.18 95.9989L149.181 95.9999Z" fill="#3D45E0"/>
          <path d="M160.599 49.768C159.766 49.768 158.988 49.243 158.705 48.411C157.958 46.211 156.939 44.331 155.677 42.823C155.669 42.814 155.661 42.804 155.654 42.795L149.722 35.439C149.029 34.579 149.164 33.32 150.023 32.627C150.883 31.934 152.142 32.069 152.835 32.928L158.756 40.27C160.331 42.155 161.588 44.461 162.493 47.125C162.848 48.171 162.288 49.307 161.243 49.662C161.03 49.734 160.813 49.769 160.6 49.769L160.599 49.768Z" fill="#3D45E0"/>
          <path d="M154 36H144C142.895 36 142 35.105 142 34C142 32.895 142.895 32 144 32H153.172L154 31.172V28H110V31.172L110.828 32H130C131.105 32 132 32.895 132 34C132 35.105 131.105 36 130 36H110C109.47 36 108.961 35.789 108.586 35.414L106.586 33.414C106.211 33.039 106 32.53 106 32V26C106 24.895 106.895 24 108 24H156C157.105 24 158 24.895 158 26V32C158 32.53 157.789 33.039 157.414 33.414L155.414 35.414C155.039 35.789 154.53 36 154 36Z" fill="#3D45E0"/>
          <path d="M121.62 22C120.93 22 120.258 21.642 119.888 21.002C118.653 18.87 118 16.448 118 14C118 6.28 124.28 0 132 0C139.72 0 146 6.28 146 14C146 16.449 145.347 18.87 144.112 21.003C143.558 21.959 142.335 22.285 141.379 21.731C140.423 21.177 140.097 19.954 140.651 18.998C141.534 17.474 142 15.746 142 14.001C142 8.487 137.514 4.001 132 4.001C126.486 4.001 122 8.487 122 14.001C122 15.747 122.467 17.475 123.349 18.999C123.903 19.955 123.577 21.178 122.621 21.732C122.305 21.915 121.961 22.002 121.62 22.002V22Z" fill="#3D45E0"/>
          <path d="M132 18C130.895 18 130 17.105 130 16V12C130 10.895 130.895 10 132 10C133.105 10 134 10.895 134 12V16C134 17.105 133.105 18 132 18Z" fill="#3D45E0"/>
          <path d="M122 88C118.404 88 114.997 87.049 112.405 85.321C109.564 83.427 108 80.827 108 78C108 73.04 112.953 68.886 119.778 68.123C120.876 68 121.865 68.791 121.988 69.888C122.111 70.986 121.32 71.975 120.223 72.098C117.82 72.367 115.647 73.178 114.103 74.383C112.365 75.739 112.001 77.098 112.001 78C112.001 79.952 113.645 81.339 114.625 81.993C116.567 83.287 119.186 84 122.001 84C123.423 84 124.799 83.817 126.092 83.457C127.156 83.16 128.259 83.782 128.556 84.846C128.853 85.91 128.231 87.013 127.167 87.31C125.525 87.768 123.787 88 122.002 88H122Z" fill="#3D45E0"/>
          <path d="M142 88C138.404 88 134.997 87.049 132.405 85.321C129.564 83.427 128 80.827 128 78C128 76.895 128.895 76 130 76C131.105 76 132 76.895 132 78C132 79.952 133.644 81.339 134.624 81.993C136.566 83.287 139.185 84 142 84C145.72 84 149.129 82.726 150.897 80.674C151.618 79.837 152.881 79.744 153.718 80.465C154.555 81.186 154.648 82.449 153.927 83.286C151.383 86.238 146.924 88 142 88Z" fill="#3D45E0"/>
          <path d="M132 80C128.404 80 124.997 79.049 122.405 77.321C119.564 75.427 118 72.827 118 70C118 67.173 119.565 64.573 122.405 62.679C124.996 60.951 128.404 60 132 60C135.596 60 139.003 60.951 141.595 62.679C144.436 64.573 146 67.173 146 70C146 72.827 144.435 75.427 141.595 77.321C139.004 79.049 135.596 80 132 80ZM132 64C129.185 64 126.566 64.713 124.624 66.007C123.644 66.66 122 68.048 122 70C122 71.952 123.644 73.339 124.624 73.993C126.566 75.287 129.185 76 132 76C134.815 76 137.434 75.287 139.376 73.993C140.356 73.34 142 71.952 142 70C142 68.048 140.356 66.661 139.376 66.007C137.434 64.713 134.815 64 132 64Z" fill="#3D45E0"/>
          <path d="M174 95.286C173.658 95.286 173.315 95.198 173.008 95.023C172.775 94.89 167.248 91.709 161.646 86.556C158.318 83.495 155.657 80.368 153.737 77.262C151.258 73.253 150 69.255 150 65.38C150 58.003 156.002 52.001 163.379 52.001C166.141 52.001 168.792 52.838 171.045 54.421C172.179 55.218 173.172 56.173 173.999 57.256C174.826 56.174 175.819 55.218 176.953 54.421C179.206 52.838 181.857 52.001 184.619 52.001C191.996 52.001 197.998 58.003 197.998 65.38C197.998 69.255 196.741 73.253 194.261 77.262C192.34 80.368 189.679 83.495 186.352 86.556C180.75 91.709 175.223 94.89 174.99 95.023C174.683 95.199 174.34 95.286 173.998 95.286H174ZM163.379 56C158.207 56 154 60.208 154 65.379C154 77.588 169.834 88.331 174 90.945C178.165 88.331 194 77.588 194 65.379C194 60.207 189.792 56 184.621 56C182.686 56 180.83 56.585 179.254 57.693C177.711 58.777 176.54 60.278 175.868 62.035C175.572 62.809 174.829 63.321 174 63.321C173.171 63.321 172.428 62.81 172.132 62.035C171.46 60.278 170.289 58.777 168.746 57.693C167.17 56.586 165.314 56 163.379 56Z" fill="#FF0000"/>
        </g>
        <path d="M106.458 122V110.64H101.978V108H114.178V110.64H109.698V122H106.458ZM117.027 109.74C115.867 109.74 115.087 108.98 115.087 108C115.087 107.02 115.867 106.26 117.027 106.26C118.187 106.26 118.967 106.98 118.967 107.94C118.967 108.98 118.187 109.74 117.027 109.74ZM115.467 122V111.24H118.587V122H115.467ZM127.843 111.08C130.863 111.08 133.203 113.24 133.203 116.62C133.203 120 130.863 122.16 127.843 122.16C126.503 122.16 125.403 121.74 124.603 120.86V125.88H121.483V111.24H124.463V112.48C125.243 111.54 126.403 111.08 127.843 111.08ZM127.303 119.6C128.863 119.6 130.043 118.48 130.043 116.62C130.043 114.76 128.863 113.64 127.303 113.64C125.743 113.64 124.563 114.76 124.563 116.62C124.563 118.48 125.743 119.6 127.303 119.6ZM137.083 122V110.64H132.603V108H144.803V110.64H140.323V122H137.083ZM150.353 122.16C146.933 122.16 144.433 119.86 144.433 116.62C144.433 113.38 146.933 111.08 150.353 111.08C153.773 111.08 156.253 113.38 156.253 116.62C156.253 119.86 153.773 122.16 150.353 122.16ZM150.353 119.6C151.913 119.6 153.093 118.48 153.093 116.62C153.093 114.76 151.913 113.64 150.353 113.64C148.793 113.64 147.593 114.76 147.593 116.62C147.593 118.48 148.793 119.6 150.353 119.6ZM166.358 122L162.958 117.78L161.458 119.26V122H158.338V107.16H161.458V115.56L166.018 111.24H169.738L165.258 115.8L170.138 122H166.358Z" fill="#3D45E0"/>
        <defs>
          <clipPath id="clip0_1834_13831">
            <rect width="98" height="96" fill="white" transform="translate(100)"/>
          </clipPath>
        </defs>
      </svg>
    </div>

    <div class="d-flex flex-column align-items-center px-4 pb-4 mt-n5">
      <div class="d-flex flex-column align-items-center mt-2">
        <div class="d-flex align-items-center mb-3">

          <div class="position-relative flex-shrink-0">
            <div class="rounded-circle border border-white shadow"
                 style="width: 96px; height: 96px; background: url('https://lh3.googleusercontent.com/aida-public/AB6AXuAthAwz1J1QdyjsKwyasYWBp3p7SQ3CKUPOIWJp6oXdAb65pmY_DvTSAvH2eW0xZWY-fYr-pgVZQ4jAW1RG3x9Z21KZygkTk9Qa5etZc9IVmPbUvN5LM8MgzpvwGrmiukZIRHRg7mo_TJU37m447fY6kctdIO6PAzBUgqS0XEfunvBFk5tWpNTVQD5hOt_O3oTD5E9y4t6BeouVouP9oj1_3N7Vb1T-baOrttmqYYLWCh6gJYh18WUBZ-A3m1HsLEdwCk5bSY6FeKuo') center/cover no-repeat;">
            </div>
          </div>

          <div class="ms-3 text-start" style="padding-left: 15px;">
            <h1 class="h3 font-weight-bold mb-1">I'm John</h1>
            <p class="text-muted small font-weight-normal mb-0" style="max-width: 250px;">
              It was an absolute pleasure serving you today. Thank you for dining with us at Ammos Estiatorio.
            </p>
          </div>

        </div>

        <div class="text-center" style="width: 250px;">
          <star-rating [starType]="'svg'" [rating]="employeeRating" [size]="'large'" [hoverEnabled]="'true'"
                       [speed]="'noticeable'" [space]="'between'"
                       (starClickChange)="onStarClicked($event)">
          </star-rating>
        </div>
      </div>
    </div>

    <h3 class="h5 font-weight-bold px-4 pt-1 pb-2 mb-0">Select a tip amount</h3>

    <div class="px-4 pb-2">
      <div class="row no-gutters">
        <div class="col-3 px-1" *ngFor="let amount of [5, 10, 15]">
          <label class="w-100 cursor-pointer mb-0">
            <input class="sr-only" name="tip" type="radio" [value]="amount" (change)="selectPreset(amount)" [checked]="isOptionSelected(amount)"/>
            <div class="d-flex align-items-center justify-content-center rounded-2xl border transition-all"
                 style="height: 64px;"
                 [ngClass]="isOptionSelected(amount) ? 'bg-black border-dark text-white shadow' : 'bg-light border-light text-dark shadow-sm'">
              <span class="h6 mb-0 font-weight-bold">${{amount}}</span>
            </div>
          </label>
        </div>

        <div class="col-3 px-1">
          <label class="w-100 cursor-pointer mb-0">
            <input class="sr-only" name="tip" type="radio" value="custom" (change)="selectCustom()" [checked]="isOptionSelected('custom')"/>
            <div class="d-flex flex-column align-items-center justify-content-center rounded-2xl border transition-all"
                 style="height: 64px;"
                 [ngClass]="isOptionSelected('custom') ? 'bg-black border-dark text-white shadow' : 'bg-light border-light text-dark shadow-sm'">
              <span class="small font-weight-bold">Other</span>
              <fa-icon style="font-size: 14px;" [icon]="faPencil"></fa-icon>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="px-4 pt-3 pb-2" *ngIf="isOptionSelected('custom')">
      <div class="position-relative">
      <span class="position-absolute font-weight-bold"
            style="left: 15px; top: 50%; transform: translateY(-50%);">$</span>
        <input class="form-control form-control-lg rounded-2xl bg-light border-dark font-weight-bold pl-4"
               style="height: 60px; font-size: 1.1rem;"
               placeholder="0.00"
               type="number"
               [(ngModel)]="customAmount"
               (input)="onCustomAmountChange($event)"
               #customInput
               autofocus>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-end px-4 py-3">
      <span class="h5 mb-0 font-weight-bold text-dark">Tip Amount</span>
      <span class="h2 mb-0 font-weight-bold text-dark mr-2">${{ finalTipAmount }}</span>
    </div>

    <div class="bg-light p-4 rounded-top shadow-sm"
         style="border-top-left-radius: 2rem !important; border-top-right-radius: 2rem !important; flex: 1 0 auto;">
      <button class="btn btn-block rounded-pill mb-2 py-3 transition-all"
              [disabled]="isProcessing || isSuccess"
              (click)="processPrimaryPayment()"
              [ngClass]="{
          'btn-success border-success text-white': isSuccess,
          'btn-dark': !isSuccess,
          'gpay-btn': getDeviceType() === 'android' && !isSuccess,
          'apple-pay-btn': getDeviceType() !== 'android' && !isSuccess
        }">

        <span class="font-weight-bold h6 mb-0 d-flex align-items-center justify-content-center">
          <ng-container *ngIf="isSuccess">
            <fa-icon class="mr-2" [icon]="faCheckCircle"></fa-icon> Payment Done
          </ng-container>

          <ng-container *ngIf="isProcessing">
            <div class="spinner-border spinner-border-sm mr-2" role="status"></div> Processing...
          </ng-container>

          <ng-container *ngIf="!isProcessing && !isSuccess">
            <ng-container *ngIf="getDeviceType() === 'android'; else otherDevice">
              <fa-icon class="mr-2" [icon]="faGooglePay" style="font-size: 1.5rem;"></fa-icon>
            </ng-container>
            <ng-template #otherDevice>
              <fa-icon class="mr-2" [icon]="faApple" style="font-size: 1.2rem;"></fa-icon> Pay
            </ng-template>
          </ng-container>
        </span>
      </button>

      <button class="btn btn-block rounded-pill py-3 transition-all"
              [disabled]="isProcessingPaypal || isSuccessPaypal"
              (click)="processPaypalPayment()"
              [style.backgroundColor]="isSuccessPaypal ? '#28a745' : '#0070BA'"
              [style.border]="'none'"
              [style.color]="'white'">

        <span class="font-weight-bold h6 mb-0 d-flex align-items-center justify-content-center">
          <ng-container *ngIf="isSuccessPaypal">
            <fa-icon class="mr-2" [icon]="faCheckCircle"></fa-icon> Sent to PayPal
          </ng-container>

          <ng-container *ngIf="isProcessingPaypal">
            <div class="spinner-border spinner-border-sm mr-2" role="status"></div> Connecting...
          </ng-container>

          <ng-container *ngIf="!isProcessingPaypal && !isSuccessPaypal">
            <fa-icon class="mr-2" style="font-size: 19px;" [icon]="faPaypal"></fa-icon>
            <span class="font-italic">PayPal</span>
          </ng-container>
        </span>
      </button>

      <div class="text-center mt-2 text-muted opacity-50">
        <fa-icon class="mr-2" [icon]="faLock" style="font-size: 0.8rem;"></fa-icon>
        <span class="small font-weight-bold text-uppercase" style="font-size: 9px; letter-spacing: 1px;">Secure Payment</span>
      </div>
    </div>


  <div class="row align-items-center receipt-footer">
    <div class="col-7">
      <div class="ml-3 mb-1 text-white small">Powered by</div>
      <img class="col-12" src="/assets/img/f-logo.svg"/>
    </div>
    <div class="col-5 d-flex justify-content-end pr-4">
      <a href="https://supersweet.ai/" class="arrow-link text-white" target="_blank">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.2"/>
          <path
            d="M25.8115 15.7929L33.668 23.2305C33.88 23.4311 34 23.7091 34 23.9999C34 24.2908 33.88 24.5684 33.668 24.7694L25.8115 32.2069C25.3832 32.6109 24.7053 32.5957 24.2964 32.171C23.8877 31.7504 23.9031 31.0752 24.3327 30.6684L30.2563 25.0637H15.0718C14.4803 25.0637 14 24.5873 14 24.0007C14 23.4141 14.4803 22.9386 15.0718 22.9386H30.2535L24.3299 17.3339C23.9009 16.9263 23.8876 16.2511 24.2938 15.8292C24.7044 15.4042 25.3428 15.3892 25.8115 15.7929Z"
            fill="white"/>
        </svg>
      </a>
    </div>
  </div>
  <img class="mh-12" src="/assets/img/supersweet-ribbon.png"/>
</div>